type Props = {
  message?: string
}

export default function NoContent({ message = "No hay informacion disponibles" }: Props) {
  return (
    <div className="uppercase bg-white p-3  shadow col-span-full text-center border-b-4 border-b-[#F1C30F]">
      <p>{message}</p>
    </div>
  );
}
